<template>
  <VaNavbar class="app-layout-navbar app-navbar--traffic">
    <template #left>
      <div class="left">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            class="navbar-icon"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="14px"
            style="margin-top: 3px"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>
        <RouterLink :to="{ name: 'wim-dashboard' }" class="logo-link" aria-label="WIM speed dashboard">
          <VuesticLogo :height="60" start="#ffffff" class="navbar-logo" />
        </RouterLink>
      </div>
    </template>

    <!-- 20240930 comment - Hide search in lean version.
    <template #center >
      <div class="w-[530px]">
        <VaInput  class="py-5 px-6"
           preset="solid"
          placeholder="Search quick actions"
        >
      <template #prependInner>
        <VaIcon
          name="manage_search"
        />
      </template>
        </VaInput>
      
      </div>
    </template>
  -->
    <template #right>
      <!-- Lean top bar: hide Modules / Settings / Users, keep theme + profile -->
      <!--
      <RouterLink to="/modules" class="modules-link">
        <div class="modules-container">
          <VaIcon name="apps" class="navbar-icon" size="24px" />
          <span class="modules-text">Modules</span>
        </div>
      </RouterLink>
      <RouterLink to="/settings" class="modules-link">
        <div class="modules-container">
          <VaIcon name="settings" class="navbar-icon" size="24px" />
          <span class="modules-text">Settings</span>
        </div>
      </RouterLink>
      <RouterLink to="/users" class="modules-link">
        <div class="modules-container">
          <VaIcon name="group" class="navbar-icon" size="24px" />
          <span class="modules-text">Users</span>
        </div>
      </RouterLink>
      -->
      <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" />
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../../stores/global-store'
import AppNavbarActions from './components/AppNavbarActions.vue'
import VuesticLogo from '../VuesticLogo.vue'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()

const { isSidebarMinimized } = storeToRefs(GlobalStore)
</script>

<style lang="scss" scoped>
/* Traffic management navbar: balanced height + refined colors */
.app-navbar--traffic,
:deep(.va-navbar),
.app-layout-navbar,
.app-layout-navbar :deep(.va-navbar) {
  background: linear-gradient(
    180deg,
    var(--va-navbar-bg, var(--va-primary)) 0%,
    var(--va-navbar-bg-bottom, var(--va-primary-dark)) 100%
  ) !important;
  border-bottom: var(--va-navbar-border-width, 1px) solid var(--va-navbar-border-color);
  box-shadow: none;
  min-height: 48px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.app-layout-navbar :deep(.va-navbar__content) {
  min-height: 48px !important;
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
  padding-left: 0 !important;
}

/* Minimal left space so logo sits close to the edge */
.app-layout-navbar :deep(.va-navbar__content > *:first-child),
.app-layout-navbar :deep([class*='va-navbar'] > *:first-child) {
  padding-left: 0 !important;
  margin-left: 0 !important;
}

.va-navbar {
  z-index: 2;

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 0;
  margin-right: 0;
  width: 100%;
  padding: 6px 350px 6px 0.5rem;

  & > * {
    margin-right: 0.75rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}

.modules-link {
  text-decoration: none;
  margin-right: 0.5rem;
}

.modules-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}

.navbar-icon {
  color: var(--va-navbar-text-color, #000000) !important;
}

.modules-text {
  color: var(--va-navbar-text-color, #000000);
  font-size: 0.75rem;
  font-weight: 500;
}

.logo-link {
  padding: 2px 10px 2px 0;
  display: inline-flex;
  align-items: center;
  margin-left: 0;
}
</style>
